import styled from "styled-components";

export const Table = styled.table`
  border-radius: 10px 10px 0px 0px;
  overflow: hidden;
  & td {
    border-bottom: ${(props) =>
      props.showBottomBorder ? "0.5px solid #3f9dff" : "transparent"};
    padding: 0.8rem 0.2rem;
  }
`;

export const TopHeader = styled.h1`
  justify-content: center;
  text-transform: lowercase;
  font-family: "Inter";
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: 0.6px;
  display: flex;
  padding: 12px 12px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  padding-top: 0px;
  flex: 1;
`;

export const HomeWrapper = styled.div`
  transition: margin-left 0.2s ease-in;
  padding: 0px 70px;
  padding-bottom: 20px;
  box-sizing: border-box;
  background: #fff;
  margin-left: 200px;
  padding-top: 30px;
`;

export const Icon = styled.img`
  width: 1.8rem;
  transition: 0.2s all ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;
